export const environment = {
  production: true,
  buildId: '3360815927121821',
  configFile: 'config.json',
};
